import * as z from "zod";
import { monitoringNavSource, monitoringTab } from "./monitoringAnalytics";
import { mutator } from "./mutator";

/**
 * Telemetry-only mutator: there is no page-view event anywhere in 3B, so a
 * Monitoring tab view is invisible to the warehouse unless the client says so.
 * The payload reaches the analytics stream through
 * `analyticsPropsForMutation`, so the body has nothing to write.
 */
export const markMonitoringTabViewedSchema = z.object({
  tab: monitoringTab,
  visitId: z.string().max(64),
  navSource: monitoringNavSource,
  priorTab: monitoringTab.nullish(),
  urlWindow: z.number().nullish(),
  urlSort: z.string().max(64).nullish(),
  urlRouteSort: z.string().max(64).nullish(),
  otelSessionId: z.string().max(64).nullish(),
});

export const markMonitoringTabViewed = mutator({
  schema: markMonitoringTabViewedSchema,
  resolve: {},
  permissions: { none: "records that the caller looked at their own screen" },
  fn: async () => {},
});
